// Generated by purs version 0.13.0
"use strict";
var initLevel = {
    currentLevel: 1,
    currentXp: 0
};
var experienceToNextLevel = function (v) {
    return 200 + (v.currentLevel * 150 | 0) | 0;
};
var isReadyToLevelUp = function (v) {
    return function (xp) {
        return (xp + v.currentXp | 0) >= experienceToNextLevel(v);
    };
};
module.exports = {
    initLevel: initLevel,
    isReadyToLevelUp: isReadyToLevelUp,
    experienceToNextLevel: experienceToNextLevel
};
